import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=9b508536&scoped=true&"
import script from "./Achievement.vue?vue&type=script&lang=js&"
export * from "./Achievement.vue?vue&type=script&lang=js&"
import style0 from "./Achievement.vue?vue&type=style&index=0&id=9b508536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b508536",
  null
  
)

export default component.exports